<template>
  <div class="page">
    <div class="page__wrapper pt-5">
      <app-loader v-if="loader" />
      <app-agreement v-else-if="!agreementAccepted" />
      <v-card
        v-for="it in navigation"
        v-else
        :key="it.id"
        elevation="1"
        color="yellow lighten-4"
        class="card-custom"
        ripple
        @click="goTo(it)"
      >
        <v-card-text>
          {{ it.title }}
        </v-card-text>
      </v-card>
    </div>
    <div class="page__actions">
      <v-btn
        class="mt-auto"
        color="error lighten-1"
        x-large
        @click="logout"
      >
        Выход
      </v-btn>
      <v-btn
        v-if="!agreementAccepted && !loader"
        color="primary"
        class="ml-auto"
        x-large
        @click="$store.commit('toggleAgreementAcceptance', true)"
      >
        Принять
      </v-btn>
    </div>
    <result-modal
      v-model="resultModal"
      title="У вас уже есть машина в работе"
      :text="carInWork"
    />
    <result-modal
      v-model="errorModal"
      :title="errorText"
    />
  </div>
</template>

<script>
import ResultModal from '@/components/ResultModal.vue';
import AppAgreement from '@/components/AppAgreement.vue';
import { mapState } from 'vuex';

export default {
  name: 'Navigation',
  components: {
    ResultModal,
    AppAgreement,
  },
  data: () => ({
    loader: true,
    userIntefaces: [],
    carInWork: '',
    carInfo: null,
    resultModal: false,
    errorModal: false,
    errorText: '',
  }),
  computed: {
    ...mapState(['agreementAccepted']),
    navigation() {
      const navigation = [{
        id: 'Reception',
        title: 'Приемка',
        url: '/reception/acceptance',
      }, {
        id: 'Moving',
        title: 'Свободное перемещение',
        url: this.carInWork ? `/moving-car-in-work/${this.carInWork}` : '/moving',
      }, {
        id: 'MovementShipping',
        title: 'Перемещение на отгрузку',
        url: this.carInWork && this.carInfo?.operation === 'ПеремещениеНаОтгрузку'
          ? `/moving-car-in-work/${this.carInWork}`
          : '/movement-shipping',
      }, {
        id: 'CarrierTransmission',
        title: 'Передача перевозчику',
        url: '/carrier-transmission',
      }, {
        id: 'EntryEexit',
        title: 'Въезд / Выезд автовозов',
        url: '/car-carriers',
      }, {
        id: 'Return',
        title: 'Возврат',
        url: '/reception/return',
      }, {
        id: 'QualityAttention',
        title: 'Контроль качества',
        url: '/quality-attention',
      }];
      return navigation.filter((navItem) => this.userIntefaces.some((inteface) => navItem.id === inteface.id));
    },
  },
  async created() {
    Promise.all([
      this.getCarByUser(),
      this.getUserInterfaces(),
    ]).catch((e) => {
      this.onErrorHandler(e);
    }).finally(() => {
      this.loader = false;
    });
  },
  methods: {
    async getUserInterfaces() {
      const { data } = await this.$http.get('MobileOperatorInterface/Users/Interfaces');
      this.userIntefaces = data;
      return Promise.resolve();
    },
    async getCarByUser() {
      const { data: vin } = await this.$http.get('MobileOperatorInterface/BasicOperations/CarByUser');
      if (vin) {
        this.carInWork = vin;
        await this.getCarInfo();
      }
      return Promise.resolve();
    },
    async getCarInfo() {
      const { data } = await this.$http.get(`MobileOperatorInterface/BasicOperations/Car/${this.carInWork}`).catch((e) => {
        this.onErrorHandler(e);
      });
      this.carInfo = data;
      return Promise.resolve(data);
    },
    goTo(navItem) {
      if (navItem.id === 'Moving' && this.carInfo?.operation === 'ПеремещениеНаОтгрузку') {
        this.resultModal = true;
        return;
      }
      this.$router.push(navItem.url);
    },
    async logout() {
      await this.$http.post('Logout');
      this.$store.commit('toggleAgreementAcceptance', false);
    },
    onErrorHandler(e) {
      this.errorModal = true;
      this.errorText = e?.response?.data?.errorMess || 'Ошибка сервера';
    },
  },
};
</script>
